export const CARDS_TYPE = {
  0: 'card-As',
  1: 'card-2s',
  2: 'card-3s',
  3: 'card-4s',
  4: 'card-5s',
  5: 'card-6s',
  6: 'card-7s',
  7: 'card-8s',
  8: 'card-9s',
  9: 'card-10s',
  10: 'card-Js',
  11: 'card-Qs',
  12: 'card-Ks',
  13: 'card-Ah',
  14: 'card-2h',
  15: 'card-3h',
  16: 'card-4h',
  17: 'card-5h',
  18: 'card-6h',
  19: 'card-7h',
  20: 'card-8h',
  21: 'card-9h',
  22: 'card-10h',
  23: 'card-Jh',
  24: 'card-Qh',
  25: 'card-Kh',
  26: 'card-Ad',
  27: 'card-2d',
  28: 'card-3d',
  29: 'card-4d',
  30: 'card-5d',
  31: 'card-6d',
  32: 'card-7d',
  33: 'card-8d',
  34: 'card-9d',
  35: 'card-10d',
  36: 'card-Jd',
  37: 'card-Qd',
  38: 'card-Kd',
  39: 'card-Ac',
  40: 'card-2c',
  41: 'card-3c',
  42: 'card-4c',
  43: 'card-5c',
  44: 'card-6c',
  45: 'card-7c',
  46: 'card-8c',
  47: 'card-9c',
  48: 'card-10c',
  49: 'card-Jc',
  50: 'card-Qc',
  51: 'card-Kc',
  52: 'CUTTING_CARD',
  53: 'UNKNOWN',
};

export const UNKNOWN_CARD_TYPE = 53;
export const CUTTING_CARD = 52;

export const MAX_BURNED_CARDS_COUNT_IN_BOX = 11;

export const BURNED_CARDS_BOX = new Array(MAX_BURNED_CARDS_COUNT_IN_BOX).fill(null);

export const CARD_VIEW_TYPES = {
  calodeOne: 'calode-1',
  calodeTwo: 'calode-2',
};

export const CUTTING_CARD_VIEW_TYPES = 'backside-5';

export const CARD_BACKSIDE_TYPES = {
  backsideOne: 'backside-1',
  backsideTwo: 'backside-2',
  backsideThree: 'backside-3',
  backsideFour: 'backside-4',
};

export const CARDS = {
  SPADES_ACE: 0,
  SPADES_2: 1,
  SPADES_3: 2,
  SPADES_4: 3,
  SPADES_5: 4,
  SPADES_6: 5,
  SPADES_7: 6,
  SPADES_8: 7,
  SPADES_9: 8,
  SPADES_10: 9,
  SPADES_JACK: 10,
  SPADES_QUEEN: 11,
  SPADES_KING: 12,
  HEARTS_ACE: 13,
  HEARTS_2: 14,
  HEARTS_3: 15,
  HEARTS_4: 16,
  HEARTS_5: 17,
  HEARTS_6: 18,
  HEARTS_7: 19,
  HEARTS_8: 20,
  HEARTS_9: 21,
  HEARTS_10: 22,
  HEARTS_JACK: 23,
  HEARTS_QUEEN: 24,
  HEARTS_KING: 25,
  DIAMONDS_ACE: 26,
  DIAMONDS_2: 27,
  DIAMONDS_3: 28,
  DIAMONDS_4: 29,
  DIAMONDS_5: 30,
  DIAMONDS_6: 31,
  DIAMONDS_7: 32,
  DIAMONDS_8: 33,
  DIAMONDS_9: 34,
  DIAMONDS_10: 35,
  DIAMONDS_JACK: 36,
  DIAMONDS_QUEEN: 37,
  DIAMONDS_KING: 38,
  CLUBS_ACE: 39,
  CLUBS_2: 40,
  CLUBS_3: 41,
  CLUBS_4: 42,
  CLUBS_5: 43,
  CLUBS_6: 44,
  CLUBS_7: 45,
  CLUBS_8: 46,
  CLUBS_9: 47,
  CLUBS_10: 48,
  CLUBS_JACK: 49,
  CLUBS_QUEEN: 50,
  CLUBS_KING: 51,
  CUTTING_CARD: 52,
  UNKNOWN: 53,
};

const cardType = {
  DIAMOND: 'diamond',
  SPADES: 'spades',
  CLOVER: 'clover',
  HEART: 'heart',
};

const cardColor = {
  black: 'black',
  red: 'red',
};

export const CARDS_TYPES_DATA = {
  0: { icon: cardType.SPADES, name: 'A', color: cardColor.black },
  1: { icon: cardType.SPADES, name: '2', color: cardColor.black },
  2: { icon: cardType.SPADES, name: '3', color: cardColor.black },
  3: { icon: cardType.SPADES, name: '4', color: cardColor.black },
  4: { icon: cardType.SPADES, name: '5', color: cardColor.black },
  5: { icon: cardType.SPADES, name: '6', color: cardColor.black },
  6: { icon: cardType.SPADES, name: '7', color: cardColor.black },
  7: { icon: cardType.SPADES, name: '8', color: cardColor.black },
  8: { icon: cardType.SPADES, name: '9', color: cardColor.black },
  9: { icon: cardType.SPADES, name: '10', color: cardColor.black },
  10: { icon: cardType.SPADES, name: 'J', color: cardColor.black },
  11: { icon: cardType.SPADES, name: 'Q', color: cardColor.black },
  12: { icon: cardType.SPADES, name: 'K', color: cardColor.black },

  13: { icon: cardType.HEART, name: 'A', color: cardColor.red },
  14: { icon: cardType.HEART, name: '2', color: cardColor.red },
  15: { icon: cardType.HEART, name: '3', color: cardColor.red },
  16: { icon: cardType.HEART, name: '4', color: cardColor.red },
  17: { icon: cardType.HEART, name: '5', color: cardColor.red },
  18: { icon: cardType.HEART, name: '6', color: cardColor.red },
  19: { icon: cardType.HEART, name: '7', color: cardColor.red },
  20: { icon: cardType.HEART, name: '8', color: cardColor.red },
  21: { icon: cardType.HEART, name: '9', color: cardColor.red },
  22: { icon: cardType.HEART, name: '10', color: cardColor.red },
  23: { icon: cardType.HEART, name: 'J', color: cardColor.red },
  24: { icon: cardType.HEART, name: 'Q', color: cardColor.red },
  25: { icon: cardType.HEART, name: 'K', color: cardColor.red },

  26: { icon: cardType.DIAMOND, name: 'A', color: cardColor.red },
  27: { icon: cardType.DIAMOND, name: '2', color: cardColor.red },
  28: { icon: cardType.DIAMOND, name: '3', color: cardColor.red },
  29: { icon: cardType.DIAMOND, name: '4', color: cardColor.red },
  30: { icon: cardType.DIAMOND, name: '5', color: cardColor.red },
  31: { icon: cardType.DIAMOND, name: '6', color: cardColor.red },
  32: { icon: cardType.DIAMOND, name: '7', color: cardColor.red },
  33: { icon: cardType.DIAMOND, name: '8', color: cardColor.red },
  34: { icon: cardType.DIAMOND, name: '9', color: cardColor.red },
  35: { icon: cardType.DIAMOND, name: '10', color: cardColor.red },
  36: { icon: cardType.DIAMOND, name: 'J', color: cardColor.red },
  37: { icon: cardType.DIAMOND, name: 'Q', color: cardColor.red },
  38: { icon: cardType.DIAMOND, name: 'K', color: cardColor.red },

  39: { icon: cardType.CLOVER, name: 'A', color: cardColor.black },
  40: { icon: cardType.CLOVER, name: '2', color: cardColor.black },
  41: { icon: cardType.CLOVER, name: '3', color: cardColor.black },
  42: { icon: cardType.CLOVER, name: '4', color: cardColor.black },
  43: { icon: cardType.CLOVER, name: '5', color: cardColor.black },
  44: { icon: cardType.CLOVER, name: '6', color: cardColor.black },
  45: { icon: cardType.CLOVER, name: '7', color: cardColor.black },
  46: { icon: cardType.CLOVER, name: '8', color: cardColor.black },
  47: { icon: cardType.CLOVER, name: '9', color: cardColor.black },
  48: { icon: cardType.CLOVER, name: '10', color: cardColor.black },
  49: { icon: cardType.CLOVER, name: 'J', color: cardColor.black },
  50: { icon: cardType.CLOVER, name: 'Q', color: cardColor.black },
  51: { icon: cardType.CLOVER, name: 'K', color: cardColor.black },
};

export const shuffleAnimType = {
  CARDS_WRP: 'cards-wrp',
  CARD_DOWN: 'card-down',
  SHUFFLE_FIRST: 'shuffle-first',
  SHUFFLE_SECOND: 'shuffle-second',
  CLOSE_SHUFFLE_SECOND: 'close-shuffle-second',
};
